import React from 'react';
import formatDuration from '../../utils/formatDuration';

export default function AnalyticsCards({ analytics }) {
  if (!analytics) return null;

  const { total_calls, sentiment, callbacks, average_duration_seconds } = analytics;

  return (
    <div className="grid grid-4">
      <div className="card">
        <h3>Total Calls</h3>
        <p style={{ fontSize: '2rem', fontWeight: 700 }}>{total_calls}</p>
      </div>

      <div className="card">
        <h3>Avg Duration</h3>
        <p style={{ fontSize: '2rem', fontWeight: 700 }}>
          {formatDuration(Math.round(average_duration_seconds))}
        </p>
      </div>

      <div className="card">
        <h3>Sentiment</h3>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
          <span className="badge badge-positive">{sentiment.positive} positive</span>
          <span className="badge badge-neutral">{sentiment.neutral} neutral</span>
          <span className="badge badge-negative">{sentiment.negative} negative</span>
        </div>
      </div>

      <div className="card">
        <h3>Callbacks</h3>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
          <span className="badge badge-pending">{callbacks.pending} pending</span>
          <span className="badge badge-initiated">{callbacks.initiated} initiated</span>
          <span className="badge badge-completed">{callbacks.completed} done</span>
          <span className="badge badge-failed">{callbacks.failed} failed</span>
        </div>
      </div>
    </div>
  );
}
